import { get } from './utils';

const calculateUniversitySavings = () => get('/university-savings/plan');

export const universitySavings = {
  calculateUniversitySavings
};
